export default __webpack_public_path__ + "static/media/wired_blog.fda017e0.jpg";